export { Slider } from './slider';
//# sourceMappingURL=index.js.map